import * as contentful from 'contentful';
import { BLOCKS, INLINES } from '@contentful/rich-text-types';
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';

function getProperty(obj, key) {
  return key.split('.').reduce((o, x) => {
    return typeof o === 'undefined' || o === null ? o : o[x];
  }, obj);
} // getProperty()
function isEntryType(entry, type) {
  return getProperty(entry, 'data.target.sys.contentType.sys.id') === type;
}
function isVideoEntry(entry) {
  return isEntryType(entry, 'video');
}
function getVideoId(url) {
  // eslint-disable-next-line
  const m = /(?:^.*(?:\?v=|\&v=)([^#\&\?]*).*)/.exec(url);
  if (m.length >= 2) return m[1];
  return url;
}

const client = contentful.createClient({
  space: process.env.CONTENTFUL_SPACE_ID,
  accessToken: process.env.CONTENTFUL_ACCESS_TOKEN,
});

export const fetchGuide = () =>
  client
    .getEntries({
      'fields.name': 'root',
      content_type: 'category',
      include: '3',
    })
    .then((entry) => {
      // console.log(entry);
      return entry.items[0];
    })
    .catch(
      /* eslint-disable no-console */
      console.error
    );

export const fetchEntry = (id) =>
  client
  .getEntry(id)
  .then((entry) => {
    return entry;
  })
  .catch(
    /* eslint-disable no-console */
    console.error
  );

export const renderEmbeddedEntryBlock = entry => {
  // console.log('Embedded Entry', entry.data); // todo: remove in prod
  if (isVideoEntry(entry)) {
    const data = getProperty(entry, 'data.target');
    const vid = getVideoId(data.fields.url);
    return `
    <section class="container-fluid">
    <div class="video-container">
    <iframe width="${data.fields.width}" height="${data.fields.height}" 
    src="https://www.youtube.com/embed/${vid}?autoplay=0&showinfo=0&controls=0&modestbranding=1" frameborder="0" allowfullscreen</iframe>
    </div> 
    </section>
`;
  }
};

export const renderEmbeddedAsset = node => {
  /* eslint-disable no-console */

  const iconleft = 10; // icon left-margin offset
  const maxheight = 200; // max image height
  const imgmargin = 10; // total margin set in css (this is immutable); need this to calculate proper icon offset

  let zoomhtml = '';
  // eslint-disable-next-line
  let imgclass = '';
  let imgattr = '';

  const img = node.data.target.fields;
  const imgsize = node.data.target.fields.file.details.image;

  // console.log('img(', img.title, ',', imgsize.width, ',', imgsize.height, '):', img);

  let imgwidthscaled = imgsize.width;
  if (imgsize.height > maxheight - imgmargin) {
    // adjust offset as image will be scaled down
    imgwidthscaled = imgsize.width * ((maxheight - imgmargin) / imgsize.height);
    let iconoffsetx = imgwidthscaled / 2;
    iconoffsetx -= iconleft;
    zoomhtml = `<span class="icon mdi mdi-arrow-expand-all" style="margin-left:-${iconoffsetx}px"></span>`;
    imgclass = 'zoom';
  }

  if (/.gif/.test(img.file.url)) {
    imgclass += ' gif';
    imgattr += ` onmouseover="this.src='${img.file.url}'"`;
  }

  let desc = img.description;
  if (typeof desc === 'undefined') desc = '';

  return `
    <div class="contentful-asset">
      <!-- ${img.title} ${imgsize.width}x${imgsize.height}  width scaled: ${imgwidthscaled} -->      
      <img class="img-responsive img-center mt-5 mb-3" style="max-width: 760px" src="${img.file.url}" title="${desc}" alt="" ${imgattr}/>        
      <!---->
      ${zoomhtml}
    </div>
    `;

  // if (typeof desc === 'undefined') desc = '';
  //
  // img = node.data.target.fields;
  // /* eslint-disable no-console */
  // console.log('img:', img);
  //
  // return `
  //   <div class="contentful-asset">
  //     <img src="${node.data.target.fields.file.url}" title="${desc}" alt="" class="responsive"/>
  //     <span class="icon mdi mdi-arrow-expand-all" style="margin-left:-50px"></span>
  //   </div>
  //   `;
};

const htmlRenderOptions = {
  renderNode: {
    [INLINES.HYPERLINK]: (node, next) =>
      `<a href="${node.data.uri}" target="_blank">${next(node.content)}</a>`,
    [BLOCKS.EMBEDDED_ASSET]: node => renderEmbeddedAsset(node),
    [BLOCKS.EMBEDDED_ENTRY]: node => renderEmbeddedEntryBlock(node),
    [INLINES.EMBEDDED_ENTRY]: () => 'inlines > embedded entry',
  },
};

export const renderDocument = document => {
  let html = '';

  try {
    html = documentToHtmlString(document, htmlRenderOptions);
  } catch (err) {
    html = `Content not available. <!-- ${err.message} -->`;
  }

  return html;
};

export const renderVideo = video => {
  /* eslint-disable no-console */
  // console.log('Video', video);
  return `<img src="${video.fields.file.url}" alt="${video.fields.title}">`;
};

// export const renderMarked = doc => {
//   return `<div class="markdown">${marked(doc, { sanitize: true })}</div>`;
// };



// WEBPACK FOOTER //
// ./src/helpers/contentful.js